import React from 'react';
import { Star } from 'lucide-react';
import ModulePage from './ModulePage';

const scanChecks = () => [
  { label: 'Review strategie', passed: false, detail: 'Actief reviews verzamelen is essentieel voor vertrouwen' },
];

export default function ReputatiePage() {
  return (
    <ModulePage
      category="reputatie"
      title="Online Reputatie"
      subtitle="Reviews, beoordelingen en vertrouwen bij klanten"
      icon={Star}
      color="#8b5cf6"
      scanChecks={scanChecks}
    />
  );
}
